import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const profileScreenModule = defineScreen({
  app: "coaching",
  screen_id: "profile",
  path: "/settings/profile",
  heading: { text: "Admin profile settings", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "allow",
    "company_admin": "allow",
    "participant": "allow",
    "cohort_lead": "allow"
  },
  states: ["ready"],
  actions: [
    { id: "fill-valid", kind: "secondary", driver: "form.fillValid" },
    { id: "submit", kind: "primary", driver: "form.submit" },
    { id: "validation-error", kind: "secondary", driver: "form.validationError" }
  ],
  recipe: "Form-1",
  data: { seedNeeds: ["readonly-walk-session", "mutation-disposable-entity"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/profile.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default profileScreenModule;
